export enum DocumentationAreaTypes {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY",
}
